import React from "react";
import { DestinationTypeEnum } from "../../../../../enums/destination";
import {
  Destination,
  ShopifyDestination,
  WordPressDestination,
} from "../../../../../models";

export const DestinationURLColumn = ({
  destination,
}: {
  destination: Destination;
}) => {
  let url: string;
  if (destination.destination_type_id === DestinationTypeEnum.SHOPIFY) {
    const shopifyDestination = destination as ShopifyDestination;
    url = `https://${shopifyDestination.destination.store_name}.myshopify.com/`;
  } else {
    const wordpressDestination = destination as WordPressDestination;
    url = wordpressDestination.destination.url;
  }

  return (
    <div
      className="truncate overflow-hidden text-primary w-max"
      onClick={(e: any) => {
        e.stopPropagation();
        window.open(url, "_blank");
      }}
    >
      {url}
    </div>
  );
};
